<template>
    <td
        ref="td"
        :class="{'td-edit': $slots.edit}"
        class="td vs-table--td"
    >
        <span @click="clicktd">
            <vs-icon
                v-if="$slots.edit"
                class="icon-edit"
                icon="edit"
            />
            <slot />
            <span
                v-if="$slots.edit"
                class="empty"
            >
                {{ data ? '' : 'Empty' }}
            </span>
        </span>
    </td>
</template>
<script>
import Vue from 'vue';
import trExpand from './VxTrExpand.vue';

export default {
    name:  'VxTd',
    props: {
        data: {
            default: null,
        },
    },
    data: () => ({
        activeEdit: false,
    }),
    watch: {
        activeEdit() {
            this.$parent.activeEdit = this.activeEdit;
        },
    },
    methods: {
        clicktd(evt) {
            if (this.$slots.edit) {
                const tr = evt.target.closest('tr');

                if (!this.activeEdit) {
                    const Trx = Vue.extend(trExpand);
                    const instance = new Trx();
                    instance.$props.colspan = 5;
                    instance.$props.close = true;
                    instance.$slots.default = this.$slots.edit;
                    instance.vm = instance.$mount();
                    instance.$on('click', this.close);
                    const nuevoParrafo = document.createElement('tr').appendChild(instance.vm.$el);
                    this.insertAfter(tr, nuevoParrafo);
                    this.activeEdit = true;
                    setTimeout(() => {
                        window.addEventListener('click', this.closeEdit);
                    }, 20);
                }
            }
        },
        insertAfter(e, i) {
            if (e.nextSibling) {
                e.parentNode.insertBefore(i, e.nextSibling);
            } else {
                e.parentNode.appendChild(i);
            }
        },
        close() {
            const tr = this.$refs.td.closest('tr');
            this.activeEdit = false;
            tr.parentNode.removeChild(tr.nextSibling);
            window.removeEventListener('click', this.closeEdit);
        },
        closeEdit(evt) {
            if (!evt.target.closest('.tr-expand') && !evt.target.closest('.vs-select--options')) {
                this.close();
            }
        },
        saveEdit() {
            this.activeEdit = false;
        },
    },
};
</script>
